import { ChartHeader } from "@msuite/ui/charts";
import { CircularProgress } from "@msuite/ui/circular-progress";
import { DashboardTile } from "@msuite/ui/dashboard";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { Stats } from "@msuite/ui/stats";
import { responseHandler } from "@msuite/ui/utils";
import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import { client } from "@/hono";
import type { DashboardTileProps } from "../shared";

export function DashboardMeasurementsItem({ item }: DashboardTileProps) {
	/** Hooks */
	const { t } = useTranslation();

	const { data } = useQuery({
		queryKey: ["dashboard", "measurements"],
		queryFn: async () => {
			const response = await client.dashboard.measurements.$get();
			const data = await responseHandler(response);
			return data;
		},
	});

	const progress =
		(guardNumber(data?.measurements.statementCount) /
			guardNumber(data?.measurements.ticketAssignmentCount)) *
		100;

	/** Render */
	return (
		<DashboardTile item={item}>
			<ChartHeader title={t("measurements.measurements")} />
			<div className="v-stack gap-2 h-max max-h-full">
				<Stats>
					<Stats.Label>{t("dashboard.open_projects")}</Stats.Label>
					<Stats.Value>{guardNumber(data?.measurements.projectCount)}</Stats.Value>
				</Stats>
				<Stats>
					<Stats.Label>{t("dashboard.missing_statements")}</Stats.Label>
					<Stats.Value>{guardNumber(data?.measurements.assignmentsNeedingStatements)}</Stats.Value>
				</Stats>
			</div>
			<div className="flex-1" />
			<div className="h-stack justify-end">
				<CircularProgress
					size={80}
					strokeWidth={10}
					value={guardNumber(formatNumber(progress, "integer"))}
					className="*:text-xl"
				/>
			</div>
		</DashboardTile>
	);
}
